import NoAccess from 'src/features/auth/components/NoAccess';

export default function NoAccessPage() {
  const handleSupport = () => {
    window.open('https://support.tekst.com');
  };
  return <NoAccess redirectUrl="/plugins/outlook/login" className="w-full" handleSupport={handleSupport} />;
}
